import {
    COLLECTION_FAILURE,
    COLLECTION_REQUEST,
    COLLECTION_SUCCESS,
    EXPORT_WIDGET_TO_CSV_FAILURE,
    EXPORT_WIDGET_TO_CSV_REQUEST,
    EXPORT_WIDGET_TO_CSV_SUCCESS,
    RESET_WIDGET_TABLE_COLUMN,
    TOGGLE_WIDGET_TABLE_COLUMN,
} from '../actions/types/dashboard-action-types';

import { combineReducers } from 'redux';

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case COLLECTION_REQUEST:
            newState = {};
            break;
        case COLLECTION_SUCCESS:
            newState = action.payload.entities.widgets;
            break;
        case RESET_WIDGET_TABLE_COLUMN:
            newState = {
                ...state,
                [action.widgetId]: {
                    ...state[action.widgetId],
                    agGrid: state[action.widgetId].agGrid.map( col => ( { ...col, hide: !col.default || col.type.includes( 'hiddenGroupColumn' ) } ) )
                }
            };
            break;
        case TOGGLE_WIDGET_TABLE_COLUMN:
            newState = {
                ...state,
                [action.widgetId]: {
                    ...state[action.widgetId],
                    agGrid: state[action.widgetId].agGrid.map( col => {
                        if( col.field !== action.columnId ){
                            return col;
                        }

                        return {
                            ...col,
                            hide: !col.hide
                        };
                    } )

                }
            };
            break;
        default:
            newState = state;
    }

    return newState;
}

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case COLLECTION_REQUEST:
            newState = true;
            break;
        case COLLECTION_SUCCESS:
        case COLLECTION_FAILURE:
            newState = false;
            break;
        default:
            newState = state;
    }

    return newState;
}

function isExporting( state = [], action ){
    let newState;
    switch( action.type ){
        case EXPORT_WIDGET_TO_CSV_REQUEST:
            newState = [...state, action.widgetId];
            break;
        case EXPORT_WIDGET_TO_CSV_SUCCESS:
        case EXPORT_WIDGET_TO_CSV_FAILURE:
            newState = state.filter( ( id ) => id !== action.widgetId );
            break;
        default:
            newState = state;
    }

    return newState;
}

export default combineReducers( {
    byId,
    isExporting,
    isLoading,
} );
